import React, { useSyncExternalStore } from "react";
import { useInstantSearch } from "react-instantsearch";
import { subscribe, getFuzzyFallback } from "./fuzzyStore";

// Bandeau affiché quand la recherche a été élargie automatiquement (0 résultat exact),
// sur le modèle « Résultats pour … » de Google.
export default function FuzzyNotice() {
  const storeFlag = useSyncExternalStore(subscribe, getFuzzyFallback, () => false);
  const { indexUiState, results } = useInstantSearch();
  // Deux sources : le store (immédiat) et l'objet résultats renvoyé par le client enveloppé
  const relaxe = storeFlag || !!(results && results.fuzzyFallback);
  const query = (indexUiState && indexUiState.query) || "";

  if (!relaxe) return null;

  return (
    <div className="fuzzy-notice" role="status">
      Aucun résultat exact pour «&nbsp;<b>{query}</b>&nbsp;». Voici des résultats approchants&nbsp;:
    </div>
  );
}
